import { ref } from '@vue/composition-api'
import  store  from '@/store'

export default function dumpStore() {

  const loading = ref(false)
  const errors = ref({})

  const blank_data = {
    type: 'dump',
    name: '',
    camp_id: null,
    device_id: null,
    camp_leave: '',
    camp_back: '',
    work_days: [],
    landfills:[],
    areas: [{
      id: 1,
      area: null,
      count: null
    }],
  
  }

  const form = ref(Object.assign({}, blank_data))

  const fetchPlan = id => {
    store.dispatch('plans/fetchPlan', id).then(r => {
      Object.assign(form.value, r.data.plan, {
        areas: r.data.plan.data.areas,       
        work_days: r.data.plan.data.work_days,
        landfills:r.data.plan.data.landfills
      })
      delete form.value.data
    })
  }

  const submit = () =>
     new Promise((resolve, reject) => {
       loading.value = true
       errors.value = {}

      store.dispatch('plans/createPlan', form.value)
        .then(r => {
          Object.assign(form.value, blank_data)
          resolve(true)
        }).catch(reason => {
          if (reason.response.status === 422)
            errors.value = reason.response.data.errors
        reject(reason.response.data.message)
      }).finally(() => loading.value = false)
    })


  return {
    loading,
    errors,
    form,
    submit,
    fetchPlan

  }
}
